import { z } from 'zod';
import { getStoresProductSchema } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/store_product.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import {
  keyNameFormPathMap,
  ValidateField,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { CreatorProduct } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/types.ts';
import { ValueAtPath } from '../../../../../../shared/type/ObjectPaths.ts';
import { extractFieldSchema } from '../../../../../../shared/zod-helper/extractFieldSchema.ts';

export const validateSingleFieldByKey = <
  M extends MODE,
  K extends ValidateField,
  ActualPath extends (typeof keyNameFormPathMap)[K], // 경로의 실제 타입
>(
  mode: M,
  keyName: K,
  // value의 타입을 CreatorProduct<M> (현재 모드) 기준으로 변경
  value: ValueAtPath<CreatorProduct<M>, ActualPath>,
): string | null => {
  const fullSchemaForMode = getStoresProductSchema(mode);
  const pathValue = keyNameFormPathMap[keyName];

  try {
    // fullSchemaForMode (CreatorProduct<M> 스키마)에서 경로에 해당하는 필드 스키마 추출
    const fieldSchema = extractFieldSchema(fullSchemaForMode, pathValue);
    if (!fieldSchema) {
      return `필드 스키마를 찾을 수 없습니다 (경로: ${pathValue}).`;
    }
    // 추출된 필드 스키마로 값(CreatorProduct<M> 기준 타입) 유효성 검사
    fieldSchema.parse(value);
    return null; // 유효성 검사 통과
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors[0]?.message ?? '유효성 검사 오류';
    }
    console.error('Unexpected validation error:', error);
    return '알 수 없는 유효성 검사 오류입니다.';
  }
};
